<rask-header [uppercase]="true">
  Inmätningstest
</rask-header>
<rask-container-block>
  <ng-container header>Inmätningtest för viol3</ng-container>
  <div class="row">
    <rask-input
      class="col-3"
      label="Virkesordernr"
      [(ngModel)]="virkesordernr">
    </rask-input>
    <rask-input
      class="col-3"
      label="AccessToken"
      (change)="accessTokenChanged()"
      [(ngModel)]="accessToken">
    </rask-input>


  </div>
  <div class="row">
    <div class="col-3">
      <rask-button
        class="col-3"
        (click)="onVirkesorderSelected()">
        Sök
      </rask-button>
      <rask-button (click)="copyFromClipboard()">Matcha från clipboard</rask-button>
    </div>
    <div class="col-3">{{ jwtTokenInfo() }} </div>

  </div>

  <rask-container-block>
    @if (rows) {
      <rask-table #table [editable]="false" [data]="rows" [options]="gridOptions" [columns]="tableColumns"
        [noScroll]="true">
      </rask-table>
    }
    <ng-container footer>
      <rask-button color="secondary" [disabled]="!canSave()" (click)="saveAll()">Spara</rask-button>
      <rask-button color="secondary" [disabled]="!canEnqueue()" (click)="runAll()">Mät alla nya</rask-button>
    </ng-container>
  </rask-container-block>
</rask-container-block>